import React from 'react';
import { Box, Typography, CircularProgress, Stack } from '@mui/material';
import UploadFileIcon from '@mui/icons-material/UploadFile';

interface FileUploadProgressProps {
  fileName: string;
  fileSize: number;
}

const FileUploadProgress: React.FC<FileUploadProgressProps> = ({ fileName, fileSize }) => {
  const formatFileSize = (sizeInBytes: number): string => {
    const kb = 1024;
    const mb = kb * 1024;
  
    if (sizeInBytes >= mb) {
      return `${(sizeInBytes / mb).toFixed(2)} MB`;
    } else {
      return `${(sizeInBytes / kb).toFixed(2)} KB`;
    }
  }

  return (
    <Box display="flex" data-testid="file-upload-progress-box" alignItems="center" mt={2} gap={2} width="100%">
      <UploadFileIcon color="primary" />
      <Box flex="1">
        <Stack direction='row' alignItems='self-end'>
          <Box>
            <Typography variant="body2">{fileName}</Typography>
            <Typography variant="caption" color="textSecondary">
              {formatFileSize(fileSize)}
            </Typography>
          </Box>
          <Box style={{ marginLeft: 10 }}>
            <CircularProgress size={20} />
          </Box>
        </Stack>
      </Box>
    </Box>
  );
};

export default FileUploadProgress;
